export default {
      id: "risk-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#risk",
      toString: function () {
        return this.url;
      }
    }